import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router/router'
import PreApproveMe from '@/services/PreApproveMe.js'
import { _ } from 'core-js'
import Navigation from '@/store/nav.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    navigation: Navigation
  },
  state: {
    company: {
      data: null,
      theme: null,
      config: null
    },

    officer: {
      data: null,
      theme: null,
      config: null
    },

    realtor: null,

    borrowers: [],
    borrowerid: false,
    borrower_index: 0,

    nav: {
      sectionid: false,
      pageid: false,
      slide: false,
      completedSections: [],
      completedPages: [],
      map: false
    },
    form: {},
    formDefault: {
      data: false,
      status: {},
      inputFields: [],
      dependedFields: []
    },
    loadData: false,
    saveData: {
      'start': {}
    },
    colors: {},
    toasts: [],

    loanType: false,
    isReady: false,
    isLoading: false,
    submitResult: null,

    loan: {
      Type: {
        value: '',
        isValid: true
      },
      BorrowerCount: {
        value: '',
        isValid: true
      }
    },
  },
  getters: {
    getCompany: (state) => {
      return state.company.data
    },
    getCompanyTheme: (state) => {
      return state.company.theme
    },
    getCompanyConfig: (state) => {
      return state.company.config
    },
    getOfficer: (state) => {
      return state.officer.data
    },
    getOfficerTheme: (state) => {
      return state.officer.theme
    },
    getOfficerConfig: (state) => {
      return state.officer.config
    },
    getRealtor: (state) => {
      return state.realtor
    },
    getAvatar: (state) => {
      if (state.officer.data)
        return state.officer.data.Avatar
      return null
    },
    getWelcomeMessage: (state) => {
      if (state.officer.config)
        return state.officer.config.LoanApplication.Smart1003UserIntroText
      else if (state.company.config)
        return state.company.config.LoanApplication.Smart1003CompanyIntroText
      return null
    },
    getFullName: (state) => {
      if (state.officer.data)
        return state.officer.data.FullName
      else if (state.company.data) {
	if (state.company.data.ManagingCompany)
          return state.company.data.ManagingCompany.Name
	else
          return state.company.data.CompanyName
      }
      else
        return null
    },
    getTitle: (state) => {
      if (state.officer.data)
        return state.officer.data.Title
      return null
    },
    getNMLS: (state) => {
      if (state.officer.data)
        return state.officer.data.NMLS
      if (state.company.data) {
        if (state.company.data.ManagingCompany)
          return state.company.data.ManagingCompany.NMLS
        else
          return state.company.data.NMLS
      }
      return null
    },
    getPhone: (state) => {
      if (state.officer.data)
        return state.officer.data.Phone
      else if (state.company.data)
        return state.company.data.PublicContact.Phone
      return null
    },
    getEmail: (state) => {
      if (state.officer.data)
        return state.officer.data.Email
      else if (state.company.data)
        return state.company.data.PublicContact.Email
      return null
    },
    getWebsite: (state) => {
      if (state.officer.data)
        return state.officer.data.Website
      return null
    },
    getToasts: (state) => {
      return state.toasts
    },
    getTerms: (state) => {
      if (state.officer.theme)
        return state.officer.theme.Terms
      else if (state.company.theme)
        return state.company.theme.Terms
      else
        return {}
    },
    getLogo: (state) => {
      if (state.officer.theme)
        return state.officer.theme.App.Logos.App
      else if (state.company.theme)
        return state.company.theme.App.Logos.App
      else
        return null
    },
    getSubmitResult: (state) => {
      return state.submitResult
    },
    pageCompleteErrors: (state, getters) => (pageid, borrowerid) => {
      for (var i = 0; i < state.nav.completedPages.length; i++)
        if (state.nav.completedPages[i].PageID == pageid && state.nav.completedPages[i].BorrowerID == borrowerid)
          return []

      return ["Incomplete Page (" + ((getters.getBorrower(borrowerid) || {}).FirstName || {}).value + "): " + (getters.getPage(pageid) || {}).Text]
    },
    isPageComplete: (state, getters) => (pageid, borrowerid) => {
      return getters.pageCompleteErrors(pageid, borrowerid).length === 0
    },
    pageValidErrors: (state, getters) => (sectionid, pageid, borrowerid) => {
      borrowerid = (typeof borrowerid !== 'undefined') ? borrowerid : state.borrowerid
      sectionid = (typeof sectionid !== 'undefined') ? sectionid : state.nav.sectionid
      pageid = (typeof pageid !== 'undefined') ? pageid : state.nav.pageid

      var status = []
      for (let i = 0; i < state.form.status[borrowerid][sectionid][pageid].length; i++) {
        const currField = state.form.status[borrowerid][sectionid][pageid][i]
        if (!currField.isValid) {
          if (currField.CustomError)
            status.push(currField.CustomError)
          else
            status.push("Invalid Field (" + ((getters.getBorrower(borrowerid) || {}).FirstName || {}).value + "): " + currField.Text)
        }
      }
      return status
    },
    isPageValid: (state, getters) => (sectionid, pageid, borrowerid) => {
      return getters.pageValidErrors(sectionid, pageid, borrowerid).length === 0
    },
    sectionValidErrors: (state, getters) => (id, ignorePageComplete) => {
      var status = []
      var pages = getters.getSectionFamilyPages(id)
      var borrowers = getters.getBorrowers
      var requireAllBorrowers = getters.getSectionBorrowerScope(id)

      for (var i = 0; i < pages.length; i++) {
        // Don't count hub screen toward validation
	if (pages[i].Type === PreApproveMe.fieldTypes.HubScreen)
          continue

        var borrowerResults = []
        for (var j = 0; j < borrowers.length; j++) {
          borrowerResults.push(getters.isPageValid(pages[i].SectionID, pages[i].Id, borrowers[j].Id) && (ignorePageComplete || getters.isPageComplete(pages[i].Id, borrowers[j].Id)))
	}

	      //if (id === 'smart1003_section_borrower_data') {
		//      console.log(requireAllBorrowers)
		 //     console.log(borrowerResults)
	      //}

        var pageResult
        var borrowerid = null
	if (requireAllBorrowers) {
          pageResult = true
          for (var j = 0; j < borrowerResults.length; j++) {
            pageResult = pageResult && borrowerResults[j]

            if (!pageResult)
              borrowerid = borrowerid || borrowers[j].Id
	  }
        }
        else {
          pageResult = false
          for (var j = 0; j < borrowerResults.length; j++)
            pageResult = pageResult || borrowerResults[j]
        }

        if (!pageResult) {
          var borrowerTerm = ""
          if (borrowerid)
            borrowerTerm = " (" + ((getters.getBorrower(borrowerid) || {}).FirstName || {}).value + ")"

          status.push("Invalid Section" + borrowerTerm + ": " + getters.getSection(id).Name)
	}
      }

      return status
    },
    isSectionValid: (state, getters) => (id, ignorePageComplete) => {
      return getters.sectionValidErrors(id, ignorePageComplete).length === 0
    },
    getReady: (state) => {
      return state.isReady
    },
    getLoading: (state) => {
      return state.isLoading
    },
    getBorrowers: (state) => {
      return state.borrowers
    },
    getBorrower: (state) => (id) => {
      for (var i = 0; i < state.borrowers.length; i++)
        if (state.borrowers[i].Id === id)
          return state.borrowers[i]
      return null
    },
    getFirstNameTerm: (state) => {
      return ((state.borrowers[state.borrower_index] || {}).FirstName || {}).value
    },
    getEmployerNameTerm: (state) => {
      return (state.saveData[state.borrowerid] || {})['smart1003_borrower_employer_name'] || ""
    },
    getCompanyNameTerm: (state) => {
      return (state.company.data || {}).Name
    }
  },
  mutations: {
    setLoading(state, value) {
      state.isLoading = value
    },
    setReady(state, value) {
      state.isReady = value
    },
    setCompany(state, data) {
	    //
      state.company.data = (data || {}).Company
      state.company.theme = (data || {}).Theme
      state.company.config = (data || {}).Config
    },
    setOfficer(state, data) {
      state.officer.data = (data || {}).Officer
      state.officer.theme = (data || {}).Theme
      state.officer.config = (data || {}).Config
    },
    setRealtor(state, data) {
      state.realtor = data
    },
    initForm: (state, data) => {
      if (typeof data == 'object' && data !== null) {

        // Create Form Status and Nav Maps
        let navMap = {}
        let statusMap = {}
        let fieldResults = {
          InputFields: [],
          DependedFields: []
        }
        for (let i = 0; i < data.FormStructure.Fields.length; i++) {
          const currField = data.FormStructure.Fields[i]

          // Nav map
          if (typeof navMap[currField.SectionID] === 'undefined')
            navMap[currField.SectionID] = { Total: 0 }
          navMap[currField.SectionID].Total++
          navMap[currField.SectionID][currField.Id] =
            navMap[currField.SectionID].Total - 1

          // Status map
          for (var j = 0; j < state.borrowers.length; j++) {
            if (typeof statusMap[state.borrowers[j].Id] === 'undefined') {
              statusMap[state.borrowers[j].Id] = {}
            }
            if (typeof statusMap[state.borrowers[j].Id][currField.SectionID] == 'undefined') {
              statusMap[state.borrowers[j].Id][currField.SectionID] = {}
            }
            if (typeof statusMap[state.borrowers[j].Id][currField.SectionID][currField.Id] == 'undefined') {
              statusMap[state.borrowers[j].Id][currField.SectionID][currField.Id] = []
            }
          }

          function fieldAdd(section, field) {
            var add = true
            for (var i = 0; i < section.Inputs.length; i++)
              if (section.Inputs[i].Id === field.Id)
		 add = false

            if (add)
              section.Inputs.push(field)
	  }

          // Input Fields
          function fieldSearch(field, fieldArr, toplevel) {
            if (toplevel === true) {
              let fieldInfo = {
                Id: field.Id,
                SectionID: field.SectionID,
                Inputs: []
              }
              fieldArr.InputFields.push(fieldInfo)
            }
            if ([2, 3, 4, 5, 6, 8, 9, 10, 11, 13, 15, 19, 22, 23, 26, 27, 28, 29, 100].includes(field.Type)) {
              let section_index = fieldArr.InputFields.length - 1
              fieldAdd(fieldArr.InputFields[section_index], field)

              // Extra Basic Info fields
              if (field.Type == 3) {
                let InputFirst = {
                  Id: field.Id + '__first',
                  Type: 13,
                  Text: 'First Name',
                  Required: field.Required,
                  FieldSpan: 1,
                  // FieldSpan: 2,
                  Value:
                    field.Value && typeof field.Value.FirstName !== 'undefined'
                      ? field.Value.FirstName
                      : null
                }
                let InputMiddle = {
                  Id: field.Id + '__middle',
                  Type: 13,
                  Text: 'Middle name',
                  Required: false,
                  FieldSpan: 1,
                  // FieldSpan: 2,
                  Value:
                    field.Value && typeof field.Value.MiddleName !== 'undefined'
                      ? field.Value.MiddleName
                      : null
                }
                let InputLast = {
                  Id: field.Id + '__last',
                  Type: 13,
                  Text: 'Last Name',
                  Required: field.Required,
                  FieldSpan: 1,
                  // FieldSpan: 2,
                  Value:
                    field.Value && typeof field.Value.LastName !== 'undefined'
                      ? field.Value.LastName
                      : null
                }
                let InputSuffix = {
                  Id: field.Id + '__suffix',
                  Type: 13,
                  Text: 'Suffix',
                  Required: false,
                  FieldSpan: 1,
                  // FieldSpan: 2,
                  Value:
                    field.Value && typeof field.Value.Suffix !== 'undefined'
                      ? field.Value.Suffix
                      : null
                }
                // let InputEmail = {
                //   Id: field.Id + '__email',
                //   Type: 13,
                //   Text: 'Email Address',
                //   Required: field.Required,
                //   FieldSpan: 1,
                //   // FieldSpan: 2,
                //   Value:
                //     field.Value && typeof field.Value.Email !== 'undefined'
                //       ? field.Value.Email
                //       : null
                // }
                // let InputPhone = {
                //   Id: field.Id + '__phone',
                //   Type: 13,
                //   Text: 'Phone Number',
                //   Required: field.Required,
                //   FieldSpan: 1,
                //   // FieldSpan: 2,
                //   Value:
                //     field.Value && typeof field.Value.Phone !== 'undefined'
                //       ? field.Value.Phone
                //       : null
                // }
                fieldAdd(fieldArr.InputFields[section_index], InputFirst)
                fieldAdd(fieldArr.InputFields[section_index], InputMiddle)
                fieldAdd(fieldArr.InputFields[section_index], InputLast)
                fieldAdd(fieldArr.InputFields[section_index], InputSuffix)
                // fieldAdd(fieldArr.InputFields[section_index], InputEmail)
                // fieldAdd(fieldArr.InputFields[section_index], InputPhone)
              }

              // Extra Address fields
              if (field.Type == 6) {
                let InputAddress1 = {
                  Id: field.Id + '__address_1',
                  Type: 13,
                  Text: 'Street Address',
                  Required: field.Required,
                  FieldSpan: 4,
                  Value:
                    field.Value && typeof field.Value.Street1 !== 'undefined'
                      ? field.Value.Street1
                      : null
                }
                let InputAddress2 = {
                  Id: field.Id + '__address_2',
                  Type: 13,
                  Text: 'Apt / Ste / #',
                  Required: false,
                  FieldSpan: 2,
                  Value:
                    field.Value && typeof field.Value.Street2 !== 'undefined'
                      ? field.Value.Street2
                      : null
                }
                let InputCity = {
                  Id: field.Id + '__city',
                  Type: 13,
                  Text: 'City',
                  Required: field.Required,
                  FieldSpan: 2,
                  Value:
                    field.Value && typeof field.Value.City !== 'undefined'
                      ? field.Value.City
                      : null
                }
                let InputState = {
                  Id: field.Id + '__state',
                  Type: 2,
                  Text: 'State',
                  Required: field.Required,
                  FieldSpan: 2,
                  Value:
                    field.Value && typeof field.Value.State !== 'undefined'
                      ? field.Value.State
                      : null
                }
                let InputZip = {
                  Id: field.Id + '__zip',
                  Type: 5,
                  Text: 'Zip Code',
                  Required: field.Required,
                  FieldSpan: 2,
                  MinValue: 1000,
                  MaxValue: 99999,
                  Value:
                    field.Value && typeof field.Value.Zip !== 'undefined'
                      ? field.Value.Zip
                      : null
                }
                fieldAdd(fieldArr.InputFields[section_index], InputAddress1)
                fieldAdd(fieldArr.InputFields[section_index], InputAddress2)
                fieldAdd(fieldArr.InputFields[section_index], InputCity)
                fieldAdd(fieldArr.InputFields[section_index], InputState)
                fieldAdd(fieldArr.InputFields[section_index], InputZip)
              }
            }
            if (field.RequiredFields) {
              for (let i = 0; i < field.RequiredFields.length; i++) {
                let dependedField = field.RequiredFields[i]
                if (dependedField.FieldId && !fieldArr.DependedFields.includes(dependedField.FieldId)) {
                  // console.log('FOUND DEPENDED FIELD ' + dependedField.FieldId)
                  fieldArr.DependedFields.push(dependedField.FieldId)
                }
              }
            }
            if (field.Fields) {
              for (let row_i = 0; row_i < field.Fields.length; row_i++) {
                let currRow = field.Fields[row_i]
                for (let i = 0; i < currRow.length; i++) {
                  fieldArr = fieldSearch(currRow[i], fieldArr)
                }
              }
            }
            if (field.Body) {
              for (let i = 0; i < field.Body.length; i++) {
                fieldArr = fieldSearch(field.Body[i], fieldArr)
              }
            }
            if (field.InitialFields) {
              for (let i = 0; i < field.InitialFields.length; i++) {
                fieldArr = fieldSearch(field.InitialFields[i], fieldArr)
              }
            }
            if (field.SubsequentFields) {
              for (let i = 0; i < field.SubsequentFields.length; i++) {
                fieldArr = fieldSearch(field.SubsequentFields[i], fieldArr)
              }
            }
            return fieldArr
          }
          fieldResults = fieldSearch(currField, fieldResults, true)
        }
        state.nav.map = navMap
        state.formDefault.status = statusMap
        state.formDefault.inputFields = fieldResults.InputFields
        state.formDefault.dependedFields = fieldResults.DependedFields

        // Reset Form
        state.form = JSON.parse(JSON.stringify(state.formDefault))

        // Set Data (for reference only)
        state.form.data = data

        // Set Section, Page, and Slide number
        state.nav.sectionid = data.FormStructure.Sections[0].Id
        state.nav.pageid = data.FormStructure.Sections[0].Page
        state.nav.slide = state.nav.map[state.nav.sectionid][state.nav.pageid]
	
	// Temporary storage
	//state.nav.form = data.FormStructure
	//commit('formGo', data.FormStructure.FormStart)
      }
    },
    setSectionIncomplete: (state, section) => {
      if (typeof section === 'object') {
        if (typeof section.SectionID !== 'undefined')
          state.nav.completedSections = state.nav.completedSections.filter(e => e !== section.SectionID)
        state.nav.completedSections = state.nav.completedSections.filter(e => e !== section.Id)
      } else state.nav.completedSections = state.nav.completedSections.filter(e => e !== section)
    },
    setSectionComplete: (state, section) => {
      if (typeof section === 'object') {
        if (typeof section.SectionID !== 'undefined') {
          if (state.nav.completedSections.indexOf(section.SectionID) === -1)
            state.nav.completedSections.push(section.SectionID)
        } else if (typeof section.Id !== 'undefined') {
          if (state.nav.completedSections.indexOf(section.Id) === -1)
            state.nav.completedSections.push(section.Id)
        }
      } else if (state.nav.completedSections.indexOf(section) === -1)
        state.nav.completedSections.push(section)
    },
    setPageIncomplete: (state, page) => {
      var id = null
      if (typeof page === 'object')
        id = page.Id
      else 
        id = page

      state.nav.completedPages = state.nav.completedPages.filter(e => e.PageID !== id || e.BorrowerID !== state.borrowerid)
    },
    setPageComplete: (state, page) => {
      var id = null
      if (typeof page === 'object')
        id = page.Id
      else 
        id = page
	
      var found = false
      for (var i = 0; i < state.nav.completedPages.length; i++)
        if (state.nav.completedPages[i].PageID == id && state.nav.completedPages[i].BorrowerID == state.borrowerid)
          found = true

      if (!found)
        state.nav.completedPages.push({ PageID: id, BorrowerID: state.borrowerid })
    },
    addInput: (state, { field, sectionid, pageid }) => {
      if (field.isValid !== true) {
        if (field.Required)
          field.isValid = false
        else
          field.isValid = true
      }

      var isRepeatingGroupChild = (field.Id.match(/__\d/g) || []).length > 0
      var borrowers = [state.borrowerid]

      if (!isRepeatingGroupChild)
        for (var i = 0; i < state.borrowers.length; i++)
          if (state.borrowerid != state.borrowers[i].Id)
            borrowers.push(state.borrowers[i].Id)

      if (typeof field.Id !== 'undefined') {
        if (typeof sectionid !== 'undefined' && typeof pageid !== 'undefined') {
          // Make sure it doesn't exist already
          let fieldFound = false

          for (var j = 0; j < borrowers.length; j++) {
            for (let i = 0; i < state.form.status[borrowers[j]][sectionid][pageid].length; i++) {
              const currField = state.form.status[borrowers[j]][sectionid][pageid][i]
              if (currField.Id == field.Id) {
                fieldFound = true
              }
            }
            if (!fieldFound)
              state.form.status[borrowers[j]][sectionid][pageid].push(JSON.parse(JSON.stringify((field))))
          }
        } else {
          console.log('Error: Unable to add input "' + field.Id + '".')
        }
      } else {
        console.log('Error: Unable to add input', field)
      }
    },
    removeInput: (state, { field, sectionid, pageid }) => {
      var isRepeatingGroupChild = (field.Id.match(/__\d/g) || []).length > 0
      var borrowers = [state.borrowerid]

      if (!isRepeatingGroupChild)
        for (var i = 0; i < state.borrowers.length; i++)
          if (state.borrowerid != state.borrowers[i].Id)
            borrowers.push(state.borrowers[i].Id)

      if (typeof field.Id !== 'undefined') {
        var datakey = (typeof datakey !== 'undefined') ? datakey : state.borrowerid
        if (state.saveData[datakey] !== undefined && state.saveData[datakey][field.Id] !== undefined)
          Vue.delete(state.saveData[datakey], field.Id)

        if (typeof sectionid !== 'undefined' && typeof pageid !== 'undefined') {
          for (var j = 0; j < borrowers.length; j++) {
            let fieldIndex = false
            for (let i = 0; i < state.form.status[borrowers[j]][sectionid][pageid].length; i++) {
              const currField = state.form.status[borrowers[j]][sectionid][pageid][i]
              if (currField.Id == field.Id) {
                fieldIndex = i
              }
            }
            if (fieldIndex !== false) {
              console.log('Warning: Removing input "' + field.Id + '".')
              state.form.status[borrowers[j]][sectionid][pageid].splice(fieldIndex, 1)
            } 
            else 
              console.log('Error: Unable to remove input "' + field.Id + '".')
          }
        } else {
          console.log('Error: Unable to remove input "' + field.Id + '".')
        }
      } else {
        console.log('Error: Unable to remove input', field)
      }
    },
    initInputValue: (state, { field, sectionid, pageid, datakey }) => {
      datakey = (typeof datakey !== 'undefined') ? datakey : state.borrowerid
      if (datakey) {
        if (typeof state.saveData[datakey] == 'undefined') {
          Vue.set(state.saveData, datakey, {})
        }
        if (typeof state.saveData[datakey][field.Id] == 'undefined') {
          var defaultValue = ''
          if (field.Type === 23 && field.Display === 3) // Boolean
            defaultValue = false

          var initValue = defaultValue

          if (!isNaN(datakey)) {
            var index_term = ''
            if (datakey > 1)
              index_term = (datakey - 1) + ''

            switch (field.Id) {
              case 'smart1003_borrower_info__first':
                initValue = state.saveData['start']['loan_borrower' + index_term + '_firstname']
                break
              case 'smart1003_borrower_info__last':
                initValue = state.saveData['start']['loan_borrower' + index_term + '_lastname']
                break
              case 'smart1003_borrower_email':
                initValue = state.saveData['start']['loan_borrower' + index_term + '_email']
                break
              case 'smart1003_borrower_phone':
                initValue = state.saveData['start']['loan_borrower' + index_term + '_phone']
                break
              case 'smart1003_loan_details_loan_type':
                var stateVal = state.saveData['start']['loan_borrower' + index_term + '_loantype']
                if (stateVal !== 'HELOC')
                  initValue = stateVal
                else
                  initValue = 'Refinance'
                break
              case 'smart1003_refinance_details_type':
                var stateVal = state.saveData['start']['loan_borrower' + index_term + '_loantype']
                  if (stateVal === 'Refinance' || stateVal === 'HELOC')
                    initValue = stateVal
                break
              case 'smart1003_borrower_married_to':
                initValue = state.saveData['start']['loan_borrower' + index_term + '_spouse']

                if (initValue === undefined)
                  initValue = null

                break
              case 'smart1003_borrower_marital_status':
                if (!isNaN(state.saveData['start']['loan_borrower' + index_term + '_spouse']))
                  initValue = 'Married'
                break
	    }
          }

          field.Value = initValue || defaultValue
          Vue.set(state.saveData[datakey], field.Id, initValue || defaultValue)

          // The validation watcher won't fire if there's a duplicate value, so make sure the validation status is set correctly if we are initializing the field
          if (field.Value != defaultValue) {
            for (let i = 0; i < state.form.status[state.borrowerid][sectionid][pageid].length; i++) {
              const currField = state.form.status[state.borrowerid][sectionid][pageid][i]
              if (currField.Id == field.Id)
                currField.isValid = true
            }
          }
        }
	else {
          field.Value = state.saveData[datakey][field.Id]
	}
      } else {
        console.log('Unable to initialize input value. BorrowerID not set.')
      }
    },
    setInputValue: (state, { field, sectionid, pageid, value, datakey }) => {
      datakey = (typeof datakey !== 'undefined') ? datakey : state.borrowerid
      if (typeof field.Id !== 'undefined' && typeof sectionid !== 'undefined' && typeof pageid !== 'undefined') {
        for (let i = 0; i < state.form.status[state.borrowerid][sectionid][pageid].length; i++) {
          const currField = state.form.status[state.borrowerid][sectionid][pageid][i]
          if (currField.Id == field.Id) {
            state.form.status[state.borrowerid][sectionid][pageid][i].Value = value
            if (datakey) {
              if (typeof state.saveData[datakey] == 'undefined')
                Vue.set(state.saveData, datakey, {})
              Vue.set(state.saveData[datakey], field.Id, value)
              // console.log('Set value to ' + state.saveData[datakey][field.Id])
            } else {
              console.log('Unable to set input value. BorrowerID not set.')
            }
          }
        }
      }
    },
    setInputValid: (state, { field, sectionid, pageid }) => {
      let foundInput = false
      if (typeof field.Id !== 'undefined' && typeof sectionid !== 'undefined' && typeof pageid !== 'undefined') {
        for (let i = 0; i < state.form.status[state.borrowerid][sectionid][pageid].length; i++) {
          const currField = state.form.status[state.borrowerid][sectionid][pageid][i]
          if (currField.Id == field.Id) {
            foundInput = true
            state.form.status[state.borrowerid][sectionid][pageid][i].isValid = true
          }
        }
      }
      if (!foundInput && field.Id)
        console.log('Error: Unable to set input invalid "' + field.Id + '".')
    },
    setInputInvalid: (state, { field, sectionid, pageid }) => {
      let foundInput = false
      if (typeof field.Id !== 'undefined' && typeof sectionid !== 'undefined' && typeof pageid !== 'undefined') {
        for (let i = 0; i < state.form.status[state.borrowerid][sectionid][pageid].length; i++) {
          const currField = state.form.status[state.borrowerid][sectionid][pageid][i]
          if (currField.Id == field.Id) {
            foundInput = true
            state.form.status[state.borrowerid][sectionid][pageid][i].isValid = false
          }
        }
      }
      if (!foundInput && field.Id)
        console.log('Error: Unable to set input invalid "' + field.Id + '".')
    },
    setFormFilledOut: (state, isFilledOut) => {
      state.form.isFilledOut = (isFilledOut === false) ? false : true
    },
    setSubmitResult: (state, result) => {
      state.submitResult = result
    },
    resetForm: (state) => {
      state.form = JSON.parse(JSON.stringify(state.formDefault))
    },
    setToastHeight: (state, { toastid, height }) => {
      if (toastid && height) {
        for (let i = 0; i < state.toasts.length; i++) {
          const currToast = state.toasts[i]
          if (currToast.id == toastid) {
            state.toasts[i].height = height
            break
          }
        }
      }
    },
    closeToast: (state, toastid) => {
      if (toastid) {
        for (let i = 0; i < state.toasts.length; i++) {
          const currToast = state.toasts[i]
          if (currToast.id == toastid) {
            state.toasts[i].isActive = false
            break
          }
        }
      }
    },
    openToast: (state, { text, type, options }) => {
      if (text) {
        // Load options
        options = (typeof options == 'object') ? options : {}
        type = (typeof options !== 'undefined' && (type == 'info' || type == 'warning' || type == 'error' || type == 'success')) ? type : 'default'
        const defaultOptions = {
          title: false
        }
        options = { ...defaultOptions, ...options }

        const randomId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
        let newToast = {
          id: randomId,
          text,
          type,
          options,
          isActive: true
        }

        state.toasts.push(newToast)
      }
    },
    becomeBorrower: (state, borrower_index) => {
      if (typeof borrower_index === 'undefined' || borrower_index < 0 || borrower_index > state.borrowers.length) borrower_index = 0
      state.borrower_index = borrower_index
      state.borrowerid = state.borrowers[borrower_index].Id
      // console.log('Active Borrower became ' + state.borrowers[borrower_index].FirstName.value)
    },
    addBorrower: (state) => {
      const newBorrower = {
        Id: false,
        FirstName: {
          value: '',
          isValid: true
        },
        LastName: {
          value: '',
          isValid: true
        },
        Email: {
          value: '',
          isValid: true
        },
        Phone: {
          value: '',
          isValid: true
        },
        marriedTo: {
          value: '',
          isValid: true
        },
        fillingOnBehalf: {
          value: 'yes',
          isValid: true
        }
      }
      state.borrowers.push(newBorrower)
    },
    setBorrowerId: (state, { index, borrowerid }) => {
      state.borrowers[index].Id = borrowerid
    }
  },
  actions: {
    closeToast: ({ commit }, toastid) => {
      return new Promise((resolve) => {
        commit('closeToast', toastid)
        resolve()
      })
    },
    setToastHeight: ({ commit }, data) => {
      return new Promise((resolve) => {
        commit('setToastHeight', data)
        resolve()
      })
    },
    go: function ({}, route, params) {
      router.push({ 
        name: route,
        query: router.history.current.query,
	params: params
      })
    },
    initBorrowers: ({ state, commit }) => {
      if (state.borrowers.length === 0)
        commit('addBorrower')
    },
    initCompany({ commit }, companyid) {
      if (!companyid)
        return new Promise(function (resolve, reject) {
          resolve()
        })

      return Promise.all([
        PreApproveMe.loadCompany(companyid),
        PreApproveMe.getConfig(companyid, null),
      ])
      .then(r => {
        var company = r[0]
        var config = r[1]

        if (!company)
          return null
		      
        // Set Colors
        if (company.Theme.App.Colors.Primary.Hex) {
          let customStylesheet = document.createElement('style')
          customStylesheet.type = 'text/css'
          const css = ':root { --color-primary: ' + company.Theme.App.Colors.Primary.Hex + '; }'
          customStylesheet.appendChild(document.createTextNode(css))

          document.head.appendChild(customStylesheet)
        }

        // Set Favicon
        if (company.Theme.App.Favicon) {
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
            link.type = 'image/x-icon'
            link.rel = 'shortcut icon'
            link.href = company.Theme.App.Favicon
            document.getElementsByTagName('head')[0].appendChild(link)
	}

        commit('setCompany', { Company: company, Theme: company.Theme, Config: config })

        return company
      })
    },
    initOfficer({ commit, getters }, data) {
      if (!data.CompanyID || !data.UserID)
        return new Promise(function (resolve, reject) {
          resolve()
	})

      return Promise.all([
        PreApproveMe.loadOfficer(data.CompanyID, data.UserID),
        PreApproveMe.getConfig(data.CompanyID, data.UserID)
      ])
      .then(r => {
        var officer = r[0] || {}
        var config = r[1] || {}

        if (!officer.Profile)
          return null

        commit('setOfficer', { Officer: officer.Profile, Theme: officer.Theme, Config: config })

        return officer.Profile
      })
    },
    initRealtor({ commit, getters }, realtorId) {
      return new Promise(function (resolve, reject) {
        if (!realtorId)
          resolve()

        commit('setRealtor', realtorId)

        resolve()
      })
    },
    registerBorrowers: ({ state }) => {
      return new Promise((resolve, reject) => {
	for (var i = 0; i < state.borrowers.length; i++)
          state.borrowers[i].Id = i + 1

	      /*
        let userRequests = []
        for (let i = 0; i < state.borrowers.length; i++) {
          const currBorrower = state.borrowers[i]
          if (currBorrower.Id === false) {
            // const api_url = 'https://api.nextgenpam.com/User/Create'
            const api_url = process.env.VUE_APP_BASE_URL + 'local-data-usercreate-' + i + '.json'
            // const api_url = 'http://localhost:54683/User/Create'
            userRequests.push(axios
              .get(api_url)
              // .post(api_url, {
              //   CreateForUserID: userid,
              //   CreateForCompanyID: companyid
              // })
            )
            // axios
            //   .get(api_url)
            //   // .post(api_url, {
            //   //   CreateForUserID: userid,
            //   //   CreateForCompanyID: companyid
            //   // })
            //   .then(response => {
            //     if (response.Success === true) {
            //       currBorrower.Id = response.UserID
            //     }
            //     console.log('Fatal Error: Unable to create new User (Borrower).')
            //   }).catch(err => {
            //     currBorrower.Id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
            //     // console.log('Fatal Error: Unable to create new User (Borrower).')
            //   })
          }
        }

        axios.all(userRequests)
          .then(axios.spread((...results) => {
            for (let i = 0; i < results.length; i++) {
              const response = results[i].data
              const currBorrower = state.borrowers[i]
              if (response.Success === true) {
                currBorrower.Id = response.UserID
              } else {
                console.log('Fatal Error: Unable to create new User (Borrower): "' + currBorrower.FirstName.value + ' ' + currBorrower.LastName.value + '".')
              }
            }
            resolve()
          })).catch(err => {
            console.log('err', err)
            console.log('Fatal Error: Unable to create new User (Borrower).')
            // currBorrower.Id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
            reject(err)
          })
	      */
        resolve()
      })
    }
  }
})
